<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
    <foot></foot>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true //加载完判断是否需要重新刷新当前页面
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    // 刷新组件
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    },
    // 判断滚动条宽度
    getGun: function(){
      var odiv = document.createElement('div'),//创建一个div
      styles = {
        width: '100px',
        height: '100px',
        overflowY: 'scroll'//让他有滚动条
      }, i, scrollbarWidth;
      for (i in styles) odiv.style[i] = styles[i];
      document.body.appendChild(odiv);//把div添加到body中
      scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
      odiv.remove();//移除创建的div
      this.$store.state.scrollbarWidth = scrollbarWidth;
    },
  },

  mounted() {

  },
  updated() {
    if(!this.$route.query.index){
      window.scroll(0, 0);
    }
  },
}
</script>

<style>
body,html{
  height: 100%;
}
body,
div,
p,
span,
ul,
li,
iframe,
header,
footer,
h1,
h2,
h3,
h4,
a {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "MyFont4", sans-serif;
}

ul,
li {
  list-style: none;
}

a {
  text-decoration: none;
}

img {
  display: block;
  object-fit: cover;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  font-size: 14px;
  color: #666666;
  font-weight: 400;
}

.scroll {
  overflow-y: scroll;
  height: 100%;
  -webkit-overflow-scrolling: touch;
}

div,
input,
textarea,
p,
a {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

audio::-webkit-media-controls-enclosure{
  background: none;
}

.oneLine{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.twoLine{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

img{
  cursor: pointer;
}

  @font-face {
	font-family: "MyFont1";
	src: url("./assets/font/HYQiHei-45S.otf") format("otf");
	}

	@font-face {
	font-family: "MyFont2";
	src: url("./assets/font/TimesNewRomanBoldItalic.ttf") format("truetype");
	}

	@font-face {
	font-family: "MyFont3";
	src: url("./assets/font/TimesNewRomanBold.ttf") format("truetype");
	}

	@font-face {
	font-family: "MyFont4";
	src: url("./assets/font/TimesNewRoman.ttf") format("truetype");
	}

  @font-face {
	font-family: "MyFont5";
	src: url("./assets/font/Engravers' Old English Bold BT.ttf") format("truetype");
	}

  @font-face {
	font-family: "MyFont6";
	src: url("./assets/font/WesternNormal.ttf") format("truetype");
	} 

   @font-face {
	font-family: "MyFont7";
	src: url("./assets/font/MemphisLTPro-Bold.otf") format("truetype");
	}  

  @font-face {
	font-family: "MyFont14-AdobeMyungjoStd-Medium";
	src: url("./assets/font/AdobeMyungjoStd-Medium.otf") format("truetype");
	} 

  @font-face {
	font-family: "MyFont14-ArialMonoMTPro";
	src: url("./assets/font/ArialMonoMTPro.ttf") format("truetype");
	} 
  
  @font-face {
	font-family: "MyFont14-CenturySchoolbookBT-Monospace";
	src: url("./assets/font/CenturySchoolbookBT-Monospace.ttf") format("truetype");
	} 
  
  @font-face {
	font-family: "MyFont14-CloudsDisplayRegular";
	src: url("./assets/font/CloudsDisplayRegular.otf") format("truetype");
	} 
  
  @font-face {
	font-family: "MyFont14-English111VivaceBT-Regular";
	src: url("./assets/font/English111VivaceBT-Regular.ttf") format("truetype");
	} 
  
  @font-face {
	font-family: "MyFont14-PWGraffiti";
	src: url("./assets/font/PWGraffiti.ttf") format("truetype");
	} 

@media screen and ( max-width: 750px ) {
  
}

</style>



// WEBPACK FOOTER //
// src/App.vue